import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../../../_common/Table";
import Select from "react-select";
import _ from "lodash";
import EditLocationModal from "./EditLocationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LocationDetails from "./LocationDetails";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import "./projAdminLocations.css";
import "../styles/projAdmin.css";
import locationActions from "../../../../_actions/locationActions";
import bidItemActions from "../../../../_actions/bidItemActions";
import ccoActions from "../../../../_actions/ccoActions";
import pendingIssueActions from "../../../../_actions/pendingIssueActions";
import feederListActions from "../../../../_actions/feederListActions";
import LocationDetailsModal from "./LocationDetailsModal";

class ProjAdminLocations extends Component {
  state = {
    showEditLocationModal: false,
    showLocationDetailsModal: false,
    selectedLocationTypeFilter: null,
    selectedLocationId: null,
    sortColumn: { path: "name", order: "asc" },
    nameFilter: "",
    typeFilter: null,
    isNewLocation: false,
    locationTypeOptions: [],
  };

  columns = [
    { path: "name", label: "Location Name", thClassName: "pa-loc-list__table-th--name" },
    {
      path: "locationTypeDescription",
      label: "Location Type",
      thClassName: "pa-loc-list__table-th--type",
      content: (loc) => {
        const { locationTypeList } = this.props;
        const locType = (locationTypeList || []).find(
          (lt) => lt.locationTypeId === loc.locationTypeId
        );
        return locType ? locType.description : "(N/A)";
      },
    },
    {
      path: "description",
      label: "Description",
      thClassName: "pa-loc-list__table-th--desc",
    },
    {
      path: "edit",
      label: "",
      thClassName: "pa-loc-list__table-th--edit",
      tdClassName: "pa-loc-list__table-th--edit",
      disableSort: true,
      content: (loc) => (
        <button
          type="button"
          name="editLocation"
          id={`editLocation_${loc.locationId}`}
          className="btn btn-sm btn-secondary float-right"
          onClick={this.handleClick_editFromRow(loc)}
          onTouchEnd={this.handleClick_editFromRow(loc)}
          disabled={
            this.props.fetching ||
            !this.props.permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
            loc.isGeneric
          }
        >
          Edit...
          {this.props.fetching &&
            this.state.selectedLocationId &&
            this.state.selectedLocationId === loc.locationId && (
              <FontAwesomeIcon
                icon="spinner"
                className="fa-fw ml-1"
                spin={this.props.fetching}
              />
            )}
        </button>
      ),
    },
    {
      path: "details",
      label: "",
      thClassName: "pa-loc-list__table-th--details",
      tdClassName: "pa-loc-list__table-th--details",
      disableSort: true,
      content: (loc) => (
        <button
          type="button"
          name="locationDetails"
          id={`locationDetails_${loc.locationId}`}
          className="btn btn-sm btn-info"
          onClick={this.handleClick_detailsFromRow(loc)}
          onTouchEnd={this.handleClick_detailsFromRow(loc)}
          disabled={this.props.fetching}
        >
          Details...
          {this.props.fetching &&
            this.state.selectedLocationId &&
            this.state.selectedLocationId === loc.locationId && (
              <FontAwesomeIcon
                icon="spinner"
                className="fa-fw ml-1"
                spin={this.props.fetching}
              />
            )}
        </button>
      ),
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;

    dispatch(feederListActions.getLocationTypes());
    dispatch(locationActions.getAll(projectId));
    dispatch(bidItemActions.getAll(projectId));
    dispatch(ccoActions.getAll(projectId));
    dispatch(pendingIssueActions.getAll(projectId));

    const locationTypeOptions = this.buildLocationTypeOptions();
    this.setState({ locationTypeOptions });
  }

  componentDidUpdate(prevProps, prevState) {
    const { locationTypeList } = this.props;
    if (locationTypeList && prevProps.locationTypeList !== locationTypeList) {
      const locationTypeOptions = this.buildLocationTypeOptions();
      this.setState({ locationTypeOptions });
    }
  }

  buildLocationTypeOptions = () => {
    const { locationTypeList } = this.props;
    return _.orderBy(
      (locationTypeList || []).map((lt) => ({
        value: lt.locationTypeId,
        label: lt.description,
      })),
      "label",
      "asc"
    );
  };

  handleChange_nameFilter = (e) => this.setState({ nameFilter: e.target.value });
  handleChange_typeFilter = (typeFilter) => this.setState({ typeFilter });
  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ nameFilter: "", typeFilter: null });
  };

  handleClick_addLocation = (e) => {
    e.preventDefault();
    this.setState({ isNewLocation: true }, this.toggleEditLocationModal);
  };

  handleclick_locationTr = (selectedLocation) => {
    const { dispatch, projectId } = this.props;
    this.setState({ selectedLocationId: selectedLocation.locationId });
    dispatch(locationActions.getDetails(selectedLocation.locationId, projectId));
  };

  handleClick_detailsFromRow = (selectedLocation) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ selectedLocationId: selectedLocation.locationId }, () => {
      const { dispatch, projectId } = this.props;
      dispatch(locationActions.getDetails(selectedLocation.locationId, projectId));
      this.toggleLocationDetailsModal();
    });
  };

  handleClick_editFromRow = (selectedLocation) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(
      { isNewLocation: false, selectedLocationId: selectedLocation.locationId },
      async () => {
        const { dispatch, projectId } = this.props;
        await dispatch(
          locationActions.getDetails(selectedLocation.locationId, projectId)
        );
        this.toggleEditLocationModal();
      }
    );
  };

  editLocation = () =>
    this.setState({ isNewLocation: false }, this.toggleEditLocationModal);

  deleteLocation = () => {
    const { selectedLocationId } = this.state;
    const { dispatch, projectId } = this.props;
    dispatch(locationActions.deleteLocation(selectedLocationId, projectId));
    this.setState({ selectedLocationId: null });
  };

  toggleEditLocationModal = () =>
    this.setState({
      showEditLocationModal: !this.state.showEditLocationModal,
    });

  toggleLocationDetailsModal = () =>
    this.setState({ showLocationDetailsModal: !this.state.showLocationDetailsModal });

  getData = () => {
    const { projLocationList } = this.props;
    const { nameFilter, typeFilter, sortColumn } = this.state;

    const filteredByName = nameFilter
      ? (projLocationList || []).filter((l) =>
          l.name.toLowerCase().includes(nameFilter.trim().toLowerCase())
        )
      : projLocationList || [];
    const filteredByType = typeFilter
      ? filteredByName.filter((l) => l.locationTypeId === typeFilter.value)
      : filteredByName;
    return _.orderBy(filteredByType, [sortColumn.path], [sortColumn.order]);
  };

  renderLocationFilters = () => {
    const { nameFilter, typeFilter, locationTypeOptions } = this.state;
    const { permissions } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap w-100 mb-2 pa-filter-group">
        <div className="pa-filter-item pa-filter-item__input pa-filter-item__input--loc-name flex-grow-1 mr-2">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="nameFilter"
              id="nameFilter"
              className="form-control col-12"
              value={nameFilter}
              onChange={this.handleChange_nameFilter}
              placeholder="Location Name"
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__select--loc-type mr-2">
          <Select
            name="locationTypeFilter"
            id="locationTypeFilter"
            value={typeFilter}
            options={locationTypeOptions}
            onChange={this.handleChange_typeFilter}
            isSearchable={false}
            isClearable
            placeholder="Loc. Type"
          />
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addNewLocation"
            id="addNewLocation"
            className="btn btn-info px-2"
            onClick={this.handleClick_addLocation}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-1" />
            Add...
          </button>
        </div>
      </div>
    );
  };

  renderLocationTable = () => {
    const { sortColumn, selectedLocationId } = this.state;
    const data = this.getData();

    return (
      <div className="pa-list__table--wrapper border">
        <Table
          className="table table-sm table-hover pa-list__table"
          data={data}
          columns={this.columns}
          idPropName="locationId"
          selectedItemId={selectedLocationId}
          sortColumn={sortColumn}
          onSort={this.handleSort}
          handleClick_tr={this.handleclick_locationTr}
        />
      </div>
    );
  };

  render() {
    const {
      showEditLocationModal,
      showLocationDetailsModal,
      isNewLocation,
      selectedLocationId,
    } = this.state;
    const { permissions, projectId } = this.props;
    return (
      <React.Fragment>
        <div className="d-flex flex-row w-100 p-2">
          <div className="pa-list">
            {this.renderLocationFilters()}
            {this.renderLocationTable()}
          </div>
          <div className="pa-details">
            <div className="card mb-2 mt-0">
              <div className="card-header bg-lightgray">Location Details</div>
              <div className="card-body p-3">
                <LocationDetails
                  permissions={permissions}
                  projectId={projectId}
                  locationId={selectedLocationId}
                  deleteLocation={this.deleteLocation}
                  editLocation={this.editLocation}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditLocationModal && (
          <EditLocationModal
            isNewLocation={isNewLocation}
            locationId={selectedLocationId}
            projectId={projectId}
            showModal={showEditLocationModal}
            toggleModal={this.toggleEditLocationModal}
          />
        )}
        {showLocationDetailsModal && (
          <LocationDetailsModal
            showLocationDetailsModal={showLocationDetailsModal}
            toggleLocationDetailsModal={this.toggleLocationDetailsModal}
            permissions={permissions}
            projectId={projectId}
            locationId={selectedLocationId}
            deleteLocation={this.deleteLocation}
            editLocation={this.editLocation}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationTypeList: state.feederLists.locationTypeList || null,
  projLocationList: state.locations.projLocationLists[ownProps.projectId] || null,
  fetching: state.locations.fetching,
});

export default connect(mapStateToProps)(ProjAdminLocations);
